export default __webpack_public_path__ + "static/media/excel_icon.d53be407.svg";